export default __webpack_public_path__ + "static/media/step1.f702729e.svg";